import { factory } from '../utils'

export default {
  auto: '*',

  store: {
    getters: {
      logFactory: factory(() => ({
        userId: null,
        action: null,
        error: null,
        payload: null,
        params: null,
      })),
    },
  },
}
